import { PreloadingStrategy, Route } from "@angular/router";

import { Observable, of, timer } from "rxjs";
import { switchMap } from "rxjs/operators";
import { Injectable } from "@angular/core";

@Injectable()
export class AppPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data && route.data.preload ? this.loadRoute(load, route.data.delay) : of(null);
  }

  private loadRoute(load: () => Observable<any>, delay?: boolean): Observable<any> {
    return delay !== false ? timer(Math.random() * 5000 + 10000).pipe(switchMap(() => load())) : load();
  }
}
